import React, { useState, useEffect, useMemo } from "react";
import { Inspection } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useSite } from "../../../../contexts";
import { useChecklistSiteIndustry } from "../useChecklistSiteIndustry";
import { ChlCardIcon } from "../ChlCardIcon";
import "./ChecklistHome.scss";

const inspectionCtrl = new Inspection();

export function ChecklistHome({ onNewInspection, onGoRecords, onGoTemplates, onUseTemplate }) {
  const { accessToken }      = useAuth();
  const { site: activeSite } = useSite();
  const [siteIndustry]       = useChecklistSiteIndustry(activeSite);

  const hasSite = !!activeSite && activeSite !== "0";

  const [templates,    setTemplates]    = useState([]);
  const [usageCounts,  setUsageCounts]  = useState({});
  const [loadingTpls,  setLoadingTpls]  = useState(true);

  useEffect(() => {
    setLoadingTpls(true);
    const industryId = siteIndustry?._id || siteIndustry || undefined;
    inspectionCtrl.getTemplates(accessToken, { active: true, ...(industryId ? { industry: industryId } : {}) })
      .then((res) => setTemplates(Array.isArray(res) ? res : []))
      .catch(() => setTemplates([]))
      .finally(() => setLoadingTpls(false));
  }, [accessToken, siteIndustry]);

  // Frecuencia de uso por plantilla, a los fines de ordenar "más usados"
  // (sólo lectura, no bloquea el render de las plantillas).
  useEffect(() => {
    const params = hasSite ? { site: activeSite } : {};
    inspectionCtrl.getInspections(accessToken, params)
      .then((res) => {
        const counts = {};
        (Array.isArray(res) ? res : []).forEach((i) => {
          const id = i.template?._id || i.template;
          if (id) counts[id] = (counts[id] || 0) + 1;
        });
        setUsageCounts(counts);
      })
      .catch(() => setUsageCounts({}));
  }, [accessToken, activeSite, hasSite]);

  const topTemplates = useMemo(() => {
    return [...templates]
      .sort((a, b) => (usageCounts[b._id] || 0) - (usageCounts[a._id] || 0))
      .slice(0, 3);
  }, [templates, usageCounts]);

  return (
    <div className="clh">
      <div className="chl-card-strip">
        <div className="clh__actions">
          <button type="button" className="chl-icon-card" onClick={onNewInspection}>
            <span className="chl-icon-card__icon">
              <ChlCardIcon />
            </span>
            <span className="clh__action-text">
              <span className="chl-icon-card__title">Nueva inspección</span>
              <span className="chl-icon-card__desc">Elegí tu checklist y empezá la recorrida</span>
            </span>
          </button>

          <button type="button" className="chl-icon-card" onClick={onGoRecords}>
            <span className="chl-icon-card__icon">
              <ChlCardIcon />
            </span>
            <span className="clh__action-text">
              <span className="chl-icon-card__title">Ver registros y reportes</span>
              <span className="chl-icon-card__desc">Historial de inspección de tu fábrica</span>
            </span>
          </button>
        </div>
      </div>

      <div className="clh__section">
        <div className="chl-section-banner">
          <h3 className="chl-section-banner__title">Checklist más usados</h3>
          {templates.length > 0 && (
            <button type="button" className="clh__see-all" onClick={onGoTemplates}>Ver todos</button>
          )}
        </div>

        {loadingTpls ? (
          <div className="clh__empty">Cargando…</div>
        ) : topTemplates.length === 0 ? (
          <div className="clh__empty">Todavía no hay checklists activos para esta industria.</div>
        ) : (
          <div className="chl-card-strip">
            <div className="clh__tpl-grid">
              {topTemplates.map((tpl) => (
                <button
                  type="button"
                  key={tpl._id}
                  className="chl-icon-card"
                  onClick={() => onUseTemplate?.(tpl)}
                >
                  <span className="chl-icon-card__icon">
                    <ChlCardIcon />
                  </span>
                  <span className="chl-icon-card__title">{tpl.name}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
